<template>
  <b-card
    class="business-card"
  >
    <validation-observer ref="accountTierLevelRules">
      <b-form>
        <b-row
          v-for="(item, index) in accountTierLevelList.config"
          :key="index"
          :class="index < 0 ? 'mt-2' : 'mt-0'"
          class="mt-2"
        >
          <b-col md="6">
            <InputNumberField
              :id="`tier-level-${index + 1}`"
              v-model="item.singleDepositTransactionLimit"
              :label="`${$t('Tier Level')} ${index + 1} ${$t('Single Deposit Transaction Limit')}`"
              :error-name="`tier-level-${index + 1}`"
              rules="required|integer|positive"
              :readonly="isReadonly"
            />
          </b-col>

          <b-col md="6">
            <InputNumberField
              :id="`tier-level-cummulative-${index + 1}`"
              v-model="item.cummulativeAccountBalanceLimit"
              :label="`${$t('Tier Level')} ${index + 1} ${$t('Cummulative Account Balance Limit')}`"
              :error-name="`tier-level-cummulative-${index + 1}`"
              rules="required|integer|positive"
              :readonly="isReadonly"
            />
          </b-col>
        </b-row>

        <!-- <div
          v-if="!showSpinner"
          class="text-center"
        >
          <Button
            v-if="getUserPermission('MODIFY_SYSTEM_SETUP')"
            :label="buttonLabel"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="saveAccountTierLevel"
          />
        </div> -->
      </b-form>
    </validation-observer>
    <div class="loading-wrapper">
      <FullScreenSpinner :show="showSpinner" />
    </div>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BForm,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { required, positive } from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
// import Button from '../../../components/button/Button.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    InputNumberField,
    BForm,
    ValidationObserver,
    FullScreenSpinner,
    // Button,
  },
  directives: {
    Ripple,
  },
  mixins: [sweetAlert, permissionMixin],
  data() {
    return {
      required,
      positive,
      isDisabled: false,
      isReadonly: true,
      isEditable: true,
      isLoading: false,
      showSpinner: true,
      buttonLabel: this.$t('Edit'),
      accountTierLevelList: {
        config: [],
      },
    }
  },
  mounted() {
    this.fetchAccountTierLevel()
  },
  methods: {
    ...mapActions({
      getAccountTierLevel: 'operations/getAccountTierLevelList',
      updateAccountTierLevel: 'operations/updateAccountTierLevelAction',
    }),
    saveAccountTierLevel() {
      if (this.buttonLabel === 'Save Changes') {
        this.$refs.accountTierLevelRules.validate().then(success => {
          if (success) {
            this.confirm(this.handleSubmit, { text: this.$t('Are you sure you want to Update this Account Tier Level Configuration?') })
          }
        })
      } else {
        this.isReadonly = false
        this.isEditable = true
        this.buttonLabel = this.$t('Save Changes')
      }
    },
    async handleSubmit() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const response = await this.updateAccountTierLevel(this.accountTierLevelList)

        const { status } = await response
        if (status === 200) {
          this.fetchAccountTierLevel()
          this.alertSuccess({ text: this.$t('Your request to Update Account Tier Level Configuration was successful') })
          this.isReadonly = true
          this.isEditable = true
          this.isDisabled = false
          this.isLoading = false
          this.buttonLabel = this.$t('Edit')
        }
      } catch (error) {
        const reasonText = this.$t('Your request to Update Account Tier Level Configuration failed. Reason:')
        this.alertError({ text: `${reasonText} ${error}` })
      } finally {
        this.isEditable = true
        this.isDisabled = false
        this.isLoading = false
      }
    },
    async fetchAccountTierLevel() {
      try {
        this.showSpinner = true
        const response = await this.getAccountTierLevel()
        const { status, data } = response
        if (status === 200 && data.data) {
          this.accountTierLevelList.config = data.data
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
  },
}
</script>
<style scoped>
.custom-checkbox:last-child{
    margin-left: 20px !important;
}
.business-card {
  position: relative;
}
.loading-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -25px 0 0 -25px;
}
</style>
